import { useState } from "react";

import { ucFirstLetters } from "@aclymatepackages/formatters";
import { ToggleButtons } from "@aclymatepackages/atoms";

import CompanyDataListItem from "./CompanyDataListItem";
import { useCachedFirebaseCrud } from "../../../helpers/firebase";
import { Box, Typography } from "@mui/material";
const DisplayMeasurementSystemRow = ({ displayMeasurementSystem }) => {
  const { updateAccountData } = useCachedFirebaseCrud();

  const [measurementSystem, setMeasurementSystem] = useState(
    displayMeasurementSystem
  );

  return (
    <CompanyDataListItem
      editingComponent={
        <Box>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Choose your preferred display measurement system
          </Typography>

          <ToggleButtons
            size="small"
            value={measurementSystem}
            onChange={(newValue) => {
              setMeasurementSystem(newValue);
              updateAccountData({ displayMeasurementSystem: newValue });
            }}
            buttons={[
              { value: "tons", name: "Tons" },
              { value: "pounds", name: "Pounds" },
              { value: "kilograms", name: "Kilograms" }
            ]}
          />
        </Box>
      }
      primaryText={`${ucFirstLetters(measurementSystem)} Measurement Units`}
      secondaryText="Preferred measurement system"
    />
  );
};
export default DisplayMeasurementSystemRow;
